<template>
  <div class="radioButtonBox">
    <div class="radioButtonBox__label">
      {{ label }}
    </div>
    <div class="c-radio">
      <div v-for="item in items" :key="item.id" class="c-radio__item">
        <input
          :id="item.id"
          :name="label"
          type="radio"
          class="c-radio__input"
          :checked="item.value === value"
          @change="$emit('change', item)"
        >
        <label :for="item.id" class="c-radio__label">
          {{ item.text }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioButtonBox',
  props: {
    label: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    value: {
      required: true,
    }
  },
  emits: ['change']
}
</script>

<style lang="scss" scoped>
.radioButtonBox {
  border: 1px solid #E4E7EB;
  border-radius: 4px;
  padding: 16px 24px;
  &__label {
    font-weight: bold;
  }
  &__content {
    border: 1px solid #E4E7EB;
    display: flex;
    border-radius: 4px;
    padding: 16px 24px;
  }
}
</style>